define('layout/loading-bar',['jquery'], function ($) {
  'use strict';

  var $loadingBar = $('.loading-bar'),
    originalHeight = $loadingBar.height(),
    $win = $(window),
    $doc = $(document),
    $contentWrap = $('.content-wrap'),
    headerElements = {
      $versionWarning: $contentWrap.find('.version-warning'),
      $header: $contentWrap.find('header:first()')
    },
    headerHeight = getHeaderHeight(headerElements);
  function getHeaderHeight(headerElements) {
    var $element;
    headerHeight = 0;
    for ($element in headerElements) {
      if (headerElements[$element].length && headerElements[$element].is(':visible')) {
        headerHeight += headerElements[$element].outerHeight();
      }
    }
    return headerHeight;
  }
  function updateHeight() {
    var loadingBarHeight = $doc.height();
    if (!$loadingBar.hasClass('loading')) {
      return;
    }
    headerHeight = getHeaderHeight(headerElements);
    if (headerHeight <= $win.scrollTop()) {
      $loadingBar.addClass('fixed');
    } else {
      $loadingBar.removeClass('fixed');
    }
    if ($loadingBar.hasClass('loadingbar-covered')) {
      if (window.devicePixelRatio !== 1) {
        loadingBarHeight--;
      }
      $loadingBar.height(loadingBarHeight);
    } else {
      $loadingBar.height('');
    }
  }
  $win.on('scroll.loadingbar', function () {
    updateHeight();
  });
  return {
    start: function start(covered) {
      if (typeof covered === 'undefined') {
        covered = true;
      }
      if ($loadingBar.hasClass('loading')) {
        $loadingBar.stop();
      }
      $loadingBar.addClass('loading');
      $loadingBar.toggleClass('loadingbar-covered', covered);
      updateHeight();
    },
    stop: function stop() {
      $loadingBar.removeClass('loading fixed').height(originalHeight);
    }
  };
});
